"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const react_1 = __importDefault(require("react"));
const transitReducer = (state, action) => {
    switch (action.type) {
        case 'SET_ACCESS_CONTEXT':
            return Object.assign(Object.assign({}, state), { accessContext: action.payload.accessContext });
        case 'LOGIN_START':
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case 'LOGIN_SUCCESS':
            return Object.assign(Object.assign({}, state), { loading: false, wallet: action.payload.wallet, error: null });
        case 'LOGOUT':
            return Object.assign(Object.assign({}, state), { loading: false, wallet: null, error: null });
        case 'LOGIN_ERROR':
            return Object.assign(Object.assign({}, state), { loading: false, wallet: null, error: action.payload.error });
        default:
            return state;
    }
};
exports.initialState = {
    wallet: null,
    loading: false,
    error: null,
    accessContext: null,
    activeProviderIndex: undefined,
};
const useTransitReducer = () => {
    return react_1.default.useReducer(transitReducer, exports.initialState);
};
exports.default = useTransitReducer;
//# sourceMappingURL=useTransitReducer.js.map